import { render, staticRenderFns } from "./ImportClient.vue?vue&type=template&id=346ef5cc&scoped=true"
import script from "./ImportClient.vue?vue&type=script&lang=js"
export * from "./ImportClient.vue?vue&type=script&lang=js"
import style0 from "./ImportClient.vue?vue&type=style&index=0&id=346ef5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ef5cc",
  null
  
)

export default component.exports